module.exports = __webpack_public_path__ + "static/media/falcon-logo.264bcc32.png";